import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";
import { faChartLine } from "@fortawesome/pro-regular-svg-icons";
import { ControlChartInspectingView } from "src/components/views/spc/controlChart/controlChartInspectingView/ControlChartInspectingView.tsx";
import i18n from "i18next";
import { Dayjs } from "dayjs";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenControlChartGraphButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	controlChartId: number;
	recordsBeforeTimeLimit?: Dayjs | null;
}

export const OpenControlChartGraphButton = ({
	controlChartId,
	recordsBeforeTimeLimit,
	variant = "menu",
	label = i18n.t("graph"),
}: OpenControlChartGraphButtonProps) => {
	const { openDialog } = useGenericDialog();
	const { tenantConfig } = useTenantCustomizations();
	if (!tenantConfig.spc.enabled) return null;

	return (
		<AsyncButton
			label={label}
			icon={faChartLine}
			variant={variant}
			onClick={async () => {
				openDialog({
					title: "Control Chart",
					content: (
						<ControlChartInspectingView
							controlChartId={controlChartId}
							recordsBeforeTimeLimit={recordsBeforeTimeLimit}
						/>
					),
					agentContext: {
						key: defineAgentUiContextKey("spc.controlCharts.graph.dialog"),
						title: i18n.t("graph"),
						data: {
							controlChartId: controlChartId,
						},
					},
				});
			}}
		/>
	);
};
